import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IosInstructionBannerComponent } from './ios-instruction-banner.component';

@NgModule({
  declarations: [IosInstructionBannerComponent],
  imports: [CommonModule],
  exports: [IosInstructionBannerComponent],
})
export class IosInstructionBannerModule {}
